import ValidatedForm from './ValidatedForm';

export { Props } from './ValidatedForm';
export default ValidatedForm;
